// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type NewProductSearchQueryVariables = Types.Exact<{
  term: Types.Scalars['String']['input'];
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  count?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  facets?: Types.InputMaybe<Array<Types.FacetInput> | Types.FacetInput>;
  filter?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isBbeCatalogEnabled?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type NewProductSearchQuery = { __typename?: 'Query', getNewProductSearchResults?: { __typename?: 'NewProductSearchResults', products?: Array<{ __typename?: 'NewSearchProduct', application?: Array<string | null> | null, brand?: string | null, brandKey?: string | null, citationCount?: number | null, displayBrand?: string | null, displaySellerName?: string | null, isBBE?: boolean | null, catalogId?: string | null, isMarketplace?: boolean | null, legalName?: string | null, legalNameSuffix?: string | null, marketplaceSellerId?: string | null, marketplaceOfferId?: string | null, materialIds?: Array<string | null> | null, molecularWeight?: string | null, paMessage?: string | null, productKey?: string | null, productName?: string | null, productNameSuffix?: string | null, productNumber?: string | null, synonyms?: Array<string | null> | null, erp_type?: Array<string> | null, attributes?: Array<{ __typename?: 'NewAttribute', id?: string | null, label?: string | null, value?: string | null } | null> | null, images?: Array<{ __typename?: 'NewImage', altText?: string | null, seq?: number | null, url?: string | null } | null> | null, substance?: { __typename?: 'NewSubstance', substanceId?: string | null, substanceName?: string | null, casNumber?: string | null, substanceCount?: number | null } | null, keyAttributes?: Array<{ __typename?: 'ProductAttribute', key: string, label: string, values: Array<string> } | null> | null, sds: Array<{ __typename?: 'SdsResponseNew', type?: string | null, locale?: string | null }> } | null> | null, facets?: Array<{ __typename?: 'Facet', key: string, numToDisplay?: number | null, isHidden?: boolean | null, isCollapsed?: boolean | null, multiSelect?: boolean | null, prefix?: string | null, options: Array<{ __typename?: 'FacetOptions', value: string, count: number }> } | null> | null, metadata: { __typename?: 'NewMetadata', count: number } } | null };


export const NewProductSearchDocument = gql`
    query NewProductSearch($term: String!, $page: Int, $count: Int, $facets: [FacetInput!], $filter: String, $isBbeCatalogEnabled: Boolean) {
  getNewProductSearchResults(
    input: {term: $term, page: $page, count: $count, facets: $facets, filter: $filter, isBbeCatalogEnabled: $isBbeCatalogEnabled}
  ) {
    products {
      application
      attributes {
        id
        label
        value
      }
      brand
      brandKey
      citationCount
      displayBrand
      displaySellerName
      images {
        altText
        seq
        url
      }
      isBBE
      catalogId
      isMarketplace
      legalName
      legalNameSuffix
      marketplaceSellerId
      marketplaceOfferId
      materialIds
      molecularWeight
      paMessage
      productKey
      productName
      productNameSuffix
      productNumber
      synonyms
      substance {
        substanceId
        substanceName
        casNumber
        substanceCount
      }
      keyAttributes {
        key
        label
        values
      }
      sds {
        type
        locale
      }
      erp_type
    }
    facets {
      key
      numToDisplay
      isHidden
      isCollapsed
      multiSelect
      prefix
      options {
        value
        count
      }
    }
    metadata {
      count
    }
  }
}
    `;
export type NewProductSearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NewProductSearchQuery, NewProductSearchQueryVariables>, 'query'> & ({ variables: NewProductSearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NewProductSearchComponent = (props: NewProductSearchComponentProps) => (
      <ApolloReactComponents.Query<NewProductSearchQuery, NewProductSearchQueryVariables> query={NewProductSearchDocument} {...props} />
    );
    

/**
 * __useNewProductSearchQuery__
 *
 * To run a query within a React component, call `useNewProductSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewProductSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewProductSearchQuery({
 *   variables: {
 *      term: // value for 'term'
 *      page: // value for 'page'
 *      count: // value for 'count'
 *      facets: // value for 'facets'
 *      filter: // value for 'filter'
 *      isBbeCatalogEnabled: // value for 'isBbeCatalogEnabled'
 *   },
 * });
 */
export function useNewProductSearchQuery(baseOptions: Apollo.QueryHookOptions<NewProductSearchQuery, NewProductSearchQueryVariables> & ({ variables: NewProductSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewProductSearchQuery, NewProductSearchQueryVariables>(NewProductSearchDocument, options);
      }
export function useNewProductSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewProductSearchQuery, NewProductSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewProductSearchQuery, NewProductSearchQueryVariables>(NewProductSearchDocument, options);
        }
export function useNewProductSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewProductSearchQuery, NewProductSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewProductSearchQuery, NewProductSearchQueryVariables>(NewProductSearchDocument, options);
        }
export type NewProductSearchQueryHookResult = ReturnType<typeof useNewProductSearchQuery>;
export type NewProductSearchLazyQueryHookResult = ReturnType<typeof useNewProductSearchLazyQuery>;
export type NewProductSearchSuspenseQueryHookResult = ReturnType<typeof useNewProductSearchSuspenseQuery>;
export type NewProductSearchQueryResult = Apollo.QueryResult<NewProductSearchQuery, NewProductSearchQueryVariables>;